<div class="sms" [class.active]="status">
  {{ status ? 'Account linked' : 'Account not linked' }}
</div>
